import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

// Persisted status filter for the /wifi-vouchers transaction history
// table. Default is 'success' since operators usually care about
// completed payments; 'pending' surfaces in-flight GCash flows the
// webhook hasn't ack'd yet; 'all' = unfiltered.
//
// Stored separately from useDeviceListPrefsStore — different domain
// (vouchers vs devices) and different lifecycle (txn filter changes
// more often).

export type VoucherTxnStatusFilter = 'success' | 'pending' | 'all';

interface VoucherTxnFilterState {
   statusFilter: VoucherTxnStatusFilter;
   setStatusFilter: (f: VoucherTxnStatusFilter) => void;
}

const useVoucherTxnFilterStore = create<VoucherTxnFilterState>()(
   persist(
      (set) => ({
         statusFilter: 'success',
         setStatusFilter: (statusFilter) => set({ statusFilter }),
      }),
      {
         name: 'smartfi-voucher-txn-filter',
         storage: createJSONStorage(() => localStorage),
      }
   )
);

export default useVoucherTxnFilterStore;
